// extracted by mini-css-extract-plugin
export default {"linkHeader":"NavigationLinks_linkHeader__dyN8P"};